import React, { useState } from "react";
import styled from "styled-components";
import HamburgerMenus from "./HamburgerMenus";
import {IoMdArrowForward} from 'react-icons/io'

const Styled = {};
Styled.Drawer = styled.div`
  transition: all 0.3s ease;
  width: 100vw;
  opacity: 0;
  &.drawer-open {
    background: #cccccc;
    z-index: 9000;
    right: 0;
    transition: all 0.3s ease;
    opacity: 1;
  }
`;

const HamburgerDrawer = ({
  isBurgerOpen,
  headerHeight,
  query,
  pageType,
  slug,
  parentChapter
}) => {
  const [activeDrawer, setActiveDrawer] = useState(pageType);
  const openMenuChapters = (type) => {
    const _type = type === "pages" ? "allChapters" : type;
    setActiveDrawer(_type);
  };
  const allTopics = query["topics"].edges.map((e) => e.node);
  const sortedTopics = {};
  /* remap allTopics seperated by Chapter as key*/
  Object.keys(allTopics).forEach((index) => {
    const chapter = allTopics[index].chapter.toLowerCase();
    if (typeof sortedTopics[chapter] !== "object") {
      sortedTopics[chapter] = [];
    }
    sortedTopics[chapter].push(allTopics[index]);
  });
  const menuAll = {
    pages: [
      {
        __typename: "HamburgerButton",
        title: <>Explore the Report <IoMdArrowForward /></>,
        action: openMenuChapters,
      },
      ...query.pages.edges.map((e) => e.node),
    ],
    allChapters: [...query.chapters.edges.map((e) => e.node)].sort((a,b)=>a.title > b.title ? 1 : -1),
    chapters: [...query.chapters.edges.map((e) => e.node)].sort((a,b)=>a.title > b.title ? 1 : -1),
    topics: sortedTopics,
  };
  //console.log(menuChapters);
  return (
    <Styled.Drawer
      className={isBurgerOpen ? "drawer-open" : "drawer-closed"}
      style={{
        position: isBurgerOpen ? "fixed" : "absolute",
        top: headerHeight,
        minHeight: isBurgerOpen ? `calc(100vh - ${headerHeight}px)` : 0,
        height: isBurgerOpen ? "auto" : "1px",
        overflow: isBurgerOpen ? "scroll" : "hidden",
      }}
    >
      <HamburgerMenus
        menus={menuAll}
        pageType={pageType}
        activeDrawer={activeDrawer}
        setActiveDrawer={setActiveDrawer}
        activeSlug={slug}
        headerHeight={headerHeight}
        parentChapter={parentChapter}
      />
    </Styled.Drawer>
  );
};

export default HamburgerDrawer;
